export default __webpack_public_path__ + "static/media/Path 105.63fc48a8.svg";